import { APP_INSTALL_HANDLER, APP_PROMPT_INSTALL_SHOW } from "./mutation-types";

export default {
  [APP_INSTALL_HANDLER](state, event) {
    state.deferredPrompt = event;
  },
  [APP_PROMPT_INSTALL_SHOW](state) {
    // Show the prompt:
    state.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt:
    state.deferredPrompt.userChoice.then(choiceResult => {
      if (choiceResult.outcome === "accepted") {
        // User accepted the install prompt
      }
      state.deferredPrompt = null;
    });
  }
};
